import React from 'react';
import { SignupForm } from '../../components/auth/signup/SignupForm';
import { Logo } from '../../components/auth/login/Logo';
import { Footer } from '../../components/common/Footer';

export function SignupPage() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <div className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <Logo />
          <SignupForm />
        </div>
      </div>
      <Footer />
    </div>
  );
}